import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useTabbar } from '@common/providers/useTabbar';
import { Page } from '@common/ui/Page';

import { SignUp } from '@widgets/sign-up/SignUp';

export const Route = createFileRoute('/sign-up')({
  component: Component,
});

export default function Component() {
  const tabbar = useTabbar();

  useEffect(() => {
    tabbar.setShowNavigation(false);
  }, []);

  return (
    <Page hasBackground>
      <SignUp />
    </Page>
  );
}
